import React from 'react';
import styled from 'styled-components';
import Proptypes from 'prop-types';
import { getColor } from '../../../utils/helper';

const StyledText = styled(({ children, as: Component = 'p', ...props }) => (
  <Component {...props}>{children}</Component>
))`
  font-size: ${(props) => props.$fontSize || '14px'};
  font-family: ${({ theme, newFont }) =>
    newFont ? theme.fontFamily : 'Instrument Sans'};
  color: ${({ theme, color, colorHex }) =>
    colorHex
      ? colorHex
      : color
      ? getColor(color, theme)
      : theme.primary}!important;
  font-weight: ${(props) => props.$fontWeight || '400'};
  .text-decoration-underline {
    color: ${({ theme, color }) => getColor(color, theme)}!important;
  }
`;

StyledText.propTypes = {
  as: Proptypes.oneOfType([
    Proptypes.string,
    Proptypes.node,
    Proptypes.element,
    Proptypes.object,
  ]),
  $fontSize: Proptypes.string,
  $fontWeight: Proptypes.string,
};
export default StyledText;
